import { initialElements } from '../components/MindMap/utils/initialElements';
import { StepApiService } from '../services';
import { CourseApiService } from '../services';
import { EnrollmentApiService } from '../services';
import type { EnrollmentItem, EnrollmentDto } from '../services';
import type { CourseDetails, ModuleDto, StepDto } from '../services';

export const getCourses = async (
  page?: number,
  size?: number,
  sort?: SortState<string>
) => {
  return EnrollmentApiService.getEnrollments(
    page ?? 1,
    size ?? 1,
    sort?.name ? [`${sort.name},${sort.direction}`] : undefined
  );
};

export const getCourse = async (id: string): Promise<CourseType> => {
  return CourseApiService.getCourseDetails(id);
};
export const getEnrollment = async (enrollmentId: string) => {
  return EnrollmentApiService.getEnrollmentDetails(enrollmentId);
};
export const completeStep = (enrollmentId: string, stepId: string) => {
  return EnrollmentApiService.completeStep(enrollmentId, stepId);
};

export const getStepDetails = async (
  courseId: string,
  stepId: string
): Promise<LessonType> => {
  return StepApiService.getStepDetails(courseId, stepId);
};

export const getCourseMindMap = async (courseId: string): Promise<any> => {
  // return CourseApiService.getCourseMindMap(courseId);
  return new Promise(resolve => {
    //TODO(Kuriy): Remove when API is ready
    setTimeout(() => {
      const nodes = initialElements();
      resolve(nodes);
    }, 1000);
  });
};

export type LessonType = StepDto;
export type ModuleType = ModuleDto;
export type CourseType = CourseDetails;
export type EnrollmentType = EnrollmentDto;
export type CoursesListType = EnrollmentItem;
